import { render, staticRenderFns } from "./ChakrasSection.vue?vue&type=template&id=a3fdfeec&scoped=true&"
import script from "./ChakrasSection.vue?vue&type=script&lang=js&"
export * from "./ChakrasSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fdfeec",
  null
  
)

export default component.exports